import DefaultPageCollection from 'base/collections/page';
import JoinosCode from 'joinos_codes/models/code';

const JoinosCodeCollection = DefaultPageCollection.extend({
    model: JoinosCode,
    url: '/joinos/joinos_codes/'
});

export default JoinosCodeCollection;



// WEBPACK FOOTER //
// ./joinos_codes/collections/codes.js